/// <reference path="../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../navigation/side_nav/side_nav_left.ts"/>

angular.module('dealerware.page',[]);

namespace Dealerware {
    export namespace Page {

        "use strict";

         export var getDealerwarePageModule: () => ng.IModule = () => {
            return angular.module("dealerware.page");
        }


        import IDealerwareSideNavLeftDelegate = Dealerware.Navigation.IDealerwareSideNavLeftDelegate;

        export interface IDealerwarePageDelegate  {

            // properites
            // ----------------------------------------
            leftNavigationDelegate : IDealerwareSideNavLeftDelegate;
            configSectionKey : string;
            pageTitleKey : string;
            pageTitle : string;

            // methods
            // ----------------------------------------


        }

        export interface IDealerwarePageController {

            // properties
            // -----------------------------------------
            service : IDealerwarePageDelegate;
            title : string;

            // methods
            // ----------------------------------------

        }


        export class DealerwarePageDelegate implements IDealerwarePageDelegate {

            // properties
            // --------------------------------------------
            private _pageTitle : string;

            public pageTitleKey : string;
            public configSectionKey : string;

            public static $inject: string[] = ['$mobilityCurrentStateDelegate','$timeout','$dealerwareSideNavLeftDelegate'];

            // constructor
            // --------------------------------------------
            constructor(public $mobilityCurrentStateDelegate : any, public $timeout : any,public leftNavigationDelegate : IDealerwareSideNavLeftDelegate) {
                this.configSectionKey   =   'page';
                this.pageTitleKey       =   "title";
            }

            // Accessors
            // -------------------------------------------
            public get pageTitle() : string {
                return (this._pageTitle || this.getPageTitleFromCurrentState() || "Dealerware");
            }

            public set pageTitle(title : string) {
                this._pageTitle = title;
            }

            // methods
            // --------------------------------------------

            private getPageTitleFromCurrentState() : string {
                return this.$mobilityCurrentStateDelegate.getConfigSectionValue(this.configSectionKey,this.pageTitleKey);
            }


            public setPageTitle(title : string, setForState : boolean = false)  : void {
                this.pageTitle = title;
                if (setForState) {
                    this.setPageTitleInCurrentState(title);
                }
            }

            public setPageTitleInCurrentState(pageTitle : string)    : void {
                this.$mobilityCurrentStateDelegate.setConfigSectionValue(this.configSectionKey,this.pageTitleKey,pageTitle);
            }

        }

        export class DealerwarePageController implements IDealerwarePageController {

            // properties
            // -----------------------------------------

            public static $inject: string[] = ['$dealerwarePageDelegate'];

            public get title() : string {
                return this.service.pageTitle;
            }

            public set title(title: string) {
                if (this.service) {
                    this.service.pageTitle = title;
                }

            }

            // constructor
            // ----------------------------------------
            constructor(public service : IDealerwarePageDelegate) {
            }

            // methods
            // ----------------------------------------
        }

        export class DealerwarePageDirective implements ng.IDirective {

            public restrict         : string    =   'E';
            public controller       : any       =   '$dealerwarePageController';
            public controllerAs     : string    =   'pageController';
            public bindToController : boolean   =   true;
            public replace          : boolean   =   false;
            public scope            : Object    =   {title: '@'};
            public transclude       : boolean   =   false;
            public require          : string[]  =   [];
            // public templateUrl      : string    =   '';
            public static $inject   : string[]  =   [];

            constructor() {

            }

            public link : ng.IDirectiveLinkFn = (
                scope   :   any,
                element :   ng.IAugmentedJQuery,
                attrs   :   ng.IAttributes,
                controller    :   any
            ) => {
            }

        }


        getDealerwarePageModule().service('$dealerwarePageDelegate',DealerwarePageDelegate);
        getDealerwarePageModule().controller('$dealerwarePageController',DealerwarePageController);
        getDealerwarePageModule().directive("dealerwarePage",() => new DealerwarePageDirective());

    }
}